$.extend(true, BT, {
	checkNewCodeForPopup: function() {
    function getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); 
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]); return null;
    }
    var selector = this.selectors.newsPopup, ins = this;
    var cookieName = this.options.newsPopup.cookieName;
    var cookie = this.getCookie(cookieName);
    var codeForNewCookie = this.getCookie('codeForNew')
    new Promise(function(resolve, reject) {
      if(cookie == undefined || cookie == null || cookie == 'null') {
        if($(selector.id).length > 0) { // popup has exit
          resolve();
        } else  {
          ins.loadSnippetAjax('popup-newsletter', function() {
            resolve();
          }, 800);
        }
      }
    }).then(function() {
      if($(selector.id).length > 0) {
        var emailNode = $("#newsletterPopup").find('#newsPopupEmail')
        var codeForNew = getUrlParam('codeForNew')
        if (codeForNew) {
          ins.setCookie('codeForNew', codeForNew, 1)
          var input = document.createElement('input')
          input.setAttribute('type', 'hidden')
          input.setAttribute('name', "contact[tags]")
          input.setAttribute('value', codeForNew)
          emailNode.after(input)
        } else if (codeForNewCookie) {
          var input = document.createElement('input')
          input.setAttribute('type', 'hidden')
          input.setAttribute('name', "contact[tags]")
          input.setAttribute('value', codeForNewCookie)
          emailNode.after(input)
        }
        $(selector.id).find('button[type="submit"]').off('click').on('click', function() {
          var email = emailNode.val()
          gio('track', 'newsLetterPopup', { 'emailAddress_var': email })
        })
      }
    }, function(err) {
      // console.log(err);
    });

  }
});
BT.checkNewCodeForPopup();